export const CATALOG_STATUS_ACTIVE = 'ACTIVE';
export const CATALOG_STATUS_DRAFT = 'DRAFT';
export const CATALOG_STATUS_INACTIVE = 'INACTIVE';
export const CATALOG_STATUS_DRAFT_CREATE_IN_PROGRESS = 'DRAFT_CREATE_IN_PROGRESS';
export const CATALOG_STATUS_DRAFT_ACTIVATION_IN_PROGRESS =
  'DRAFT_ACTIVATION_IN_PROGRESS';
